const MAX_STORED_EVENT = 10;
class TrackingEventService {
    // eslint-disable-next-line no-empty-function, no-useless-constructor
    constructor(gtmPlugin) {
        this.gtmPlugin = gtmPlugin;
        this.storedEvents = [];
        this.consentmentReady = false;
    }
    storeEvent(name, eventContext) {
        if (this.storedEvents.length <= MAX_STORED_EVENT)
            this.storedEvents.push({ name, eventContext });
    }
    flushStoredEvents() {
        if (this.storedEvents.length > 0) {
            let storedEvent;
            while ((storedEvent = this.storedEvents.shift())) {
                this.getDataLayer().push({ ...storedEvent.eventContext });
                this.gtmPlugin.trackEvent({ event: storedEvent.name });
            }
        }
        this.consentmentReady = true;
    }
    getDataLayer() {
        return this.gtmPlugin.dataLayer() || [];
    }
    resetEcommerce() {
        this.getDataLayer().push({ ecommerce: null });
    }
    trackEvent(name, eventContext) {
        if (!this.consentmentReady) {
            this.storeEvent(name, eventContext);
            return;
        }
        this.getDataLayer().push({ ...eventContext });
        this.gtmPlugin.trackEvent({ event: name });
    }
}
export default TrackingEventService;
//# sourceMappingURL=analytics.service.js.map